import type { survey } from './types'
import surveyList from '../../data/surveyData.json'

export class surveyService {
  async getSurveyList(): Promise<{ data: survey[] }> {
    const suriveies = surveyList.data

    return { data: suriveies }
  }
}
